import { Functions } from "./functions";
import { MUIDataTableTextLabels } from "mui-datatables";

export type Order = "asc" | "desc";

export function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

export function getComparatorSimple(order, orderBy) {
	return order === "desc"
		? (a, b): number => descendingComparator(a, b, orderBy)
		: (a, b): number => -descendingComparator(a, b, orderBy);
}

export function getComparator<Key extends keyof any>(
	order: Order,
	orderBy: Key
): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
	return getComparatorSimple(order, orderBy);
}

export function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map(el => el[0]);
}

export function getNewSelecteds(selectedIndex: number, selected: any[], key: any): Array<any> {
	let newSelected: any[] = [];

	if (selectedIndex === -1) {
		newSelected = newSelected.concat(selected, key);
	} else if (selectedIndex === 0) {
		newSelected = newSelected.concat(selected.slice(1));
	} else if (selectedIndex === selected.length - 1) {
		newSelected = newSelected.concat(selected.slice(0, -1));
	} else if (selectedIndex > 0) {
		newSelected = newSelected.concat(
			selected.slice(0, selectedIndex),
			selected.slice(selectedIndex + 1)
		);
	}
	return newSelected;
}
export function sortTable(
	array: Array<any>,
	order: string,
	field: string,
	numerico: boolean,
	ignoreCase = false
): Array<any> {
	return array.sort((a, b) => {
		let fieldA;
		let fieldB;
		if (ignoreCase) {
			fieldA = numerico ? new Number(Functions.removeMask(a[field])) : a[field].toLowerCase();
			fieldB = numerico ? new Number(Functions.removeMask(b[field])) : b[field].toLowerCase();

		} else {
			fieldA = numerico ? new Number(Functions.removeMask(a[field])) : a[field];
			fieldB = numerico ? new Number(Functions.removeMask(b[field])) : b[field];
		}
		if (fieldA < fieldB) {
			return order.toLowerCase() === "asc" ? -1 : 1;
		}
		if (fieldA > fieldB) {
			return order.toLowerCase() === "asc" ? 1 : -1;
		}
		return 0;
	});
}

export const calcularOffset = (
	pagina: number,
	itenPorPagina: number,
	totalItens: number
): number => {
	let offset = 0;
	if (pagina > 0) {
		offset = pagina * itenPorPagina;
		if (offset >= totalItens && totalItens > 0) {
			offset = totalItens - 1;
		}
	} else {
		offset = pagina;
	}
	return offset;
};

export const textLabels: MUIDataTableTextLabels = {
	body: {
		noMatch: "Nenhum registro encontrado",
		toolTip: "Ordenar",
	},
	pagination: {
		next: "Próxima Página",
		previous: "Página Anterior",
		rowsPerPage: "Linhas por Página:",
		displayRows: "de",
	},
	toolbar: {
		search: "Pesquisar",
		downloadCsv: "Download CSV",
		print: "Imprimir",
		viewColumns: "Ver Colunas",
		filterTable: "Filtrar Resultados",
	},
	filter: {
		all: "Todos",
		title: "FILTROS",
		reset: "LIMPAR",
	},
	viewColumns: {
		title: "Mostrar Colunas",
		titleAria: "Mostrar/Ocultar Colunas",
	},
	selectedRows: {
		text: "linha(s) selecionada(s)",
		delete: "Excluir",
		deleteAria: "Excluir linha selecionada",
	}
};